module.exports = __webpack_public_path__ + "img/secure-buying.dd94437b.svg";